import { useCallback } from "react";

function usePrintTicket() {
  const printTicket = useCallback((htmlContent: string) => {
    // Create a hidden iframe to print from
    const printFrame = document.createElement("iframe");
    printFrame.style.position = "absolute";
    printFrame.style.top = "-10000px";
    printFrame.style.left = "-10000px";
    printFrame.style.width = "80mm";
    printFrame.style.height = "auto";
    document.body.appendChild(printFrame);

    const frameDoc =
      printFrame.contentDocument || printFrame.contentWindow?.document;

    if (frameDoc) {
      frameDoc.open();
      frameDoc.write(htmlContent);
      frameDoc.close();

      // Wait for content to load then print
      printFrame.onload = () => {
        setTimeout(() => {
          printFrame.contentWindow?.print();
          // Remove iframe after printing
          setTimeout(() => {
            document.body.removeChild(printFrame);
          }, 1000);
        }, 250);
      };
    }
  }, []);

  return { printTicket };
}

export default usePrintTicket;
